import { ProductCard } from './components/ProductCard';
import { SectionHeading } from './components/SectionHeading';
import { SymbolCard } from './components/SymbolCard';
import { Storefront } from './components/Storefront';
import { products } from './data/products';

const symbols = [
  { name: 'Watchtower', meaning: 'The long view. Oversight from above the noise.' },
  { name: 'Eye', meaning: 'A witness that does not blink when power moves.' },
  { name: 'Shield', meaning: 'The perimeter. The line. The duty to guard what matters.' },
  { name: 'Laurel', meaning: 'Roman authority, but earned through accountability.' },
  { name: 'Red Signal', meaning: 'Risk elevated. A human check is required.' },
  { name: 'Gold Mark', meaning: 'A premium crest against black fabric and hard systems.' },
  { name: 'Black Fabric', meaning: 'The base layer: serious, quiet, and built for the night watch.' },
];

export function App() {
  return (
    <main>
      <header className="site-header" aria-label="CUSTOS navigation">
        <a className="brand-mark" href="#top" aria-label="CUSTOS home">
          <img src="/assets/custos-mark.svg" alt="" />
          <span>CUSTOS</span>
        </a>
        <nav>
          <a href="/first-gen.html">First Gen</a>
          <a href="/drop-architecture.html">Drops</a>
          <a href="/shop.html">Shop</a>
          <a href="/commerce-next-20.html">Commerce Status</a>
          <a href="/website-next-20.html">Website Next 20</a>
          <a href="/next-20.html">Ops Next 20</a>
          <a href="#watch">Join</a>
        </nav>
      </header>

      <section className="hero" id="top">
        <div className="hero-grid" aria-hidden="true" />
        <div className="hero-copy">
          <p className="eyebrow">CUSTOS / DROP 1 / THE QUESTION LINE</p>
          <h1>WHO WATCHES THE AGENTS?</h1>
          <p className="hero-subhead">Quis custodiet?</p>
          <p className="hero-support">
            First-gen CUSTOS gear starts with the question: who watches power, who verifies the agents, and what guardrails exist before the system asks for trust?
          </p>
          <div className="hero-actions">
            <a className="button button-primary" href="/first-gen.html">See first-gen products</a>
            <a className="button button-secondary" href="/drop-architecture.html">Why the drops changed</a>
          </div>
        </div>
        <div className="hero-art" aria-label="CUSTOS shield, watchtower, and eye mark">
          <img src="/assets/custos-mark.svg" alt="CUSTOS shield watchtower eye mark" />
          <div className="signal-panel">
            <span>AGENT ACTION DETECTED</span>
            <strong>RISK LEVEL: ELEVATED</strong>
            <span>INTEGRITY: PROTECTED</span>
            <span>ROLLBACK SNAPSHOT: READY</span>
          </div>
        </div>
      </section>

      <section className="oath-section" id="oath">
        <p className="eyebrow">Brand evolution</p>
        <h2>THE QUESTION COMES FIRST.</h2>
        <strong>WHO WATCHES? QUIS CUSTODIET?</strong>
        <p>
          The oath line — WE ARE THE WATCHERS. WE HOLD THE LINE. QUIS CUSTODIET? WE DO. — is the answer. Drop 1 earns that answer by starting with the question: who watches power, agents, and guardians?
        </p>
      </section>

      <section className="drop-section" id="drop">
        <SectionHeading
          eyebrow="Drop 1 / first gen"
          title="The question line."
          body="First-gen CUSTOS products stay close to the original oversight language: Who watches? Quis custodiet? Power needs a witness. The answer/oath products become the Drop 2 evolution."
        />
        <div className="product-grid">
          {products.map((product, index) => (
            <ProductCard key={product.name} product={product} index={index} />
          ))}
        </div>
      </section>

      <Storefront />

      <section className="lore-section" id="lore">
        <SectionHeading
          eyebrow="Visual lore"
          title="Symbols for the line we hold."
          body="CUSTOS uses old civic symbols and modern oversight language to turn accountability into a field uniform."
        />
        <div className="symbol-grid">
          {symbols.map((symbol) => (
            <SymbolCard key={symbol.name} name={symbol.name} meaning={symbol.meaning} />
          ))}
        </div>
      </section>

      <section className="watch-section" id="watch">
        <div>
          <p className="eyebrow">Join the Watch</p>
          <h2>Be first to know when the first drop goes live.</h2>
          <p>
            The signup form is staged as a placeholder until the email provider is selected. No address is transmitted yet.
          </p>
        </div>
        <form className="signup-form" onSubmit={(event) => event.preventDefault()}>
          <label htmlFor="email">Email address</label>
          <div>
            <input id="email" type="email" placeholder="watcher@example.com" aria-describedby="signup-note" />
            <button type="submit">Join the Watch</button>
          </div>
          <p id="signup-note">Signup backend pending. This button is intentionally non-submitting for the first static build.</p>
        </form>
      </section>

      <footer className="site-footer">
        <div>
          <strong>CUSTOS</strong>
          <p>We are the watchers. We hold the line.</p>
        </div>
        <nav aria-label="Footer">
          <a href="/first-gen.html">First Gen</a>
          <a href="/drop-architecture.html">Drops</a>
          <a href="/shop.html">Shop</a>
          <a href="/commerce-next-20.html">Commerce Status</a>
          <a href="/product-details.html">Current Products</a>
          <a href="/website-next-20.html">Website Next 20</a>
          <a href="/next-20.html">Ops Next 20</a>
          <a href="/support.html">Contact</a>
          <a href="/privacy.html">Privacy</a>
        </nav>
      </footer>
    </main>
  );
}
